/**
 * @file
 * @author zhousheng
 */
import * as React from 'react';
import Empty from '../empty';
import { ConfigConsumer } from '../config-provider';
const renderEmpty = (des) => (<ConfigConsumer>
        {({ getPrefixCls }) => {
        const prefix = getPrefixCls('empty');
        return <Empty className={`${prefix}-small`} hasImage={false} description={des}/>;
    }}
    </ConfigConsumer>);
export default renderEmpty;
